import React from 'react'
import { Link } from 'react-router-dom'
import { Layout, Menu, Icon, message, Spin, Avatar, Button, Typography, Row, Col, Modal, Select, Form, Tooltip, Badge } from 'antd'
import PropTypes from 'prop-types'
import { withApollo } from 'react-apollo'

import { routes, initialKey, renderAllRoutes } from '../../../config/routes'
import { Queries, Mutations } from '../../../graphql'
import { clearAllStorage } from '../../../utils/auth'
import { getNotiCouts, getTotalLeaveCount, getTotalWdHospitalCount, getCookiePopupCookie } from '../../../utils/storage'
import men from '../../../assets/images/profile/men.png'
import women from '../../../assets/images/profile/women.png'
import AvatarProfile from '../AvatarProfile'
import logo from '../../../assets/images/vtrc-logo.png'
import imagePopup from '../../../assets/images/popup/S__11010051.jpg'
import { appVersion, versionWeb, checkLinkURL, passwordDecrypt } from '../../../utils/auth'
import axiosAPI, { urlAttachFile } from "../../../config/axiosAPI";
import { sendToeventLog } from '../../../utils/eventLog'
import hash from "object-hash"
import moment from 'moment'

const { Header, Footer, Sider } = Layout
const { SubMenu } = Menu
const { Text, Title } = Typography
const { Option } = Select;

class SiderLayout extends React.Component {

	rootSubmenuKeys = [routes];

	state = {
		collapsed: false,
		profile: null,
		openKeys: [],
		consent: 2,
		showModal: true,
		policy: "",
		organizationShow: false,
		selectOrganization: [],
		visibleModalCardNoOG: false,
		submenuPolicy: [],
		showModalVersion: null,
		showModalCheck:false,
		totalNotfiction:0,
		totalWdHospitalCount:0,
		totalLeaveCount:0,
		imageContent:null,
		popupCookie: false,
      	loaddingFullPage: true,
		visibleCheckPassword: false,
		profileSSO: {}
	}

	fetchListDocumentGroup = async () =>{
		const { client, location } = this.props
        const { data, errors } = await client.query({
			query: Queries.fetchListDocumentGroup,
			variables: {
				docGroupCode:"POLICY"
			}
		})
		
        await this.setState({
            submenuPolicy: data.fetchListDocumentGroup,
        })
	}

	onCollapse = collapsed => this.setState({ collapsed })

	fetchProfile = async () => {
		try {
			const { client } = this.props
			const { data } = await client.query({
				query: Queries.fetchProfile
			})


			if(data.fetchProfile){
				await this.setState({ 
					consent: data.fetchProfile.consent,
					profile: data.fetchProfile,
					imageContent:data.fetchProfile.imageContent,
				})
				// return data.fetchProfile

            let userId = null;
            let param = data.fetchProfile.employeeCodes[0];
            let sourceDb = data.fetchProfile.currentProfile.split(':')[1];
            let path = this.props.location.pathname;

            sendToeventLog(userId, param, sourceDb, path);

            await this.fetchEmployeeDetail( data.fetchProfile.employeeCodes[0])
            localStorage.setItem('objectValuePF', JSON.stringify(data.fetchProfile))
			}else{
				return null
			}
			
		} catch (e) {
			// message.error('Something went wrong. Please try again', e)
		}
	}

   fetchEmployeeDetail = async (empCode) => {
      const { client, location, match } = this.props
      const { data, errors } = await client.query({
          query: Queries.fetchEmployeeDetail,
          variables:{
              empCode,
          }
      })

      if(data.fetchEmployeeDetail){
         localStorage.setItem('objectValueEM', JSON.stringify(data.fetchEmployeeDetail))
         await this.setState({
            loaddingFullPage: false
         })
         //  await this.dropdownLeaveType();
      }else{
         await this.setState({
            loaddingFullPage: false
         })
      }
   }

	logout = async () => {
		const { client } = this.props
		const { data, errors } = await client.mutate({
			mutation: Mutations.logout,
		})
		clearAllStorage()
		window.location.href = '/login'
	}

	onOpenChange = openKeys => {
		const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
		this.setState({
			openKeys: latestOpenKey ? [latestOpenKey] : [],
		});
	};

	renderSubmenuItem = (routePath, fetchKey ,title, key) =>{
		const { collapsed, profile, submenuPolicy } = this.state

		return <Menu.Item key={key}>
					<Link
						to={{
							pathname: routePath+'/'+fetchKey,
							state: {
								subTitle: title,
								empCodeProfile: profile ? profile.employeeCodes[0] : ''
							}
						}}
						onClick={() => window.scrollTo({
							top: 0,
							left: 0,
							behavior: 'smooth'
						})}
						style={{ display: 'inline' }}
					>
						{ title }
					</Link>
				</Menu.Item>
	}

	checkDataType = (data) =>{
		const returnData = []
		if(data.postId){
			returnData['title'] = data.postTitleTH;
			returnData['id'] = data.postId;
		}else if(data.docGroupId){
			returnData['title'] = data.docGroupTitle;
			returnData['id'] = data.docGroupId;
		}

		return returnData;
	}

	renderSubmenuDynamic = (routePath, data) =>{
		const { collapsed, profile, submenuPolicy } = this.state
		let newData = [];
		return data.length !== 0 && 
				data.map((value, key) =>
					{
						newData = this.checkDataType(value)
						return this.renderSubmenuItem(routePath+'/dashboard', newData['id'], newData['title'],key) 
					}
				)
	}

   	checkShowMenuLeave = (keys) =>{
      const { collapsed, profile, submenuPolicy, totalNotfiction, totalWdHospitalCount, totalLeaveCount } = this.state
		let showMenu = false


      if(!profile.isTrial){
         if(keys == 'Leave' && profile.isCanLeave){
            showMenu = true
         }else if(keys !== 'Leave'){
            showMenu = true
         }
      }else{
         if(keys == 'course'){
            showMenu = true  
         }
      }

		console.log('profile.isEmployeeManagement', profile.isTrial)
		return showMenu
   	}

	checkShowMenuApproves = (keys) =>{
		const { collapsed, profile, submenuPolicy, totalNotfiction, totalWdHospitalCount, totalLeaveCount } = this.state
		let showMenu = false

    

		if(keys == 'hospitalConfirm' && profile.isEmployeeApprover){
			showMenu = true
		}else if(keys == 'LeaveConfirm' && profile.isEmployeeApproverLeave){
			showMenu = true
		}else if(keys == 'ListForManager' && profile.isEmployeeApproverLeave){
			showMenu = true
      	}else if(keys == 'Delegate' && profile.isEmployeeManagement){
			showMenu = true
		}else if(keys == 'LeaveCreate' && profile.isBC){
         	showMenu = true
      	}else if(keys == 'LeaveCancel' && profile.isEmployeeApproverLeave){
         	showMenu = true
      	}else if(keys == 'AbstainTimeConfirm' && profile.isEmployeeApproverLeave){
      // }else if(keys == 'AbstainTimeConfirm'){
         	showMenu = true
      	}else if(keys == 'workHistory' && profile.isShowProfileHistory){
		   	showMenu = true
		}else if(keys == 'WelfareConfirm' && profile.isEmployeeApproverWelfare){
			showMenu = true
		}


		return showMenu
	}

	renderSideMenu = () => {
		const { collapsed, profile, submenuPolicy, totalNotfiction, totalWdHospitalCount, totalLeaveCount } = this.state
		let newData = [];
		return <>
			{
				profile &&
				<Menu
					theme="dark"
					// defaultSelectedKeys={[initialKey]}
					// selectedKeys={this.getSelectedKeys()}
					openKeys={this.state.openKeys}
					onOpenChange={this.onOpenChange}
					onClick={(value) => {
						if (!value.keyPath[1]) {
							this.setState({
								openKeys: [],
							});
						}
					}}
					mode="inline"
				>
					{routes.map(route =>
						route.isShow && this.checkShowMenuLeave(route.key) ? (
							route.children && route.children.find(child => child.isShow) ? (
								<SubMenu
									key={route.key}
									title={
										<span>
											<Icon type={route.icon} />
											<span>{route.label}</span>
											{
												(route.key == 'hospital') &&
												<Badge count={totalWdHospitalCount} id="value-wdHospital-title" className=" ml-2" style={{ fontSize:"10px",padding:"0 4px 0 3px",opacity:"0" }}></Badge>
											}
											
											{
												(route.key == 'Leave') &&
												<Badge count={totalLeaveCount} id="value-LeaveCount-title" className=" ml-2" style={{ fontSize:"10px",padding:"0 4px 0 3px",opacity:"0" }}></Badge>
											}
										</span>
									}
									className="active-menu-custom"
								>
									{
                              route.children.map(
										   subRoute =>
											   subRoute.isShow && (
                                       subRoute.key !== 'hospitalConfirm' && 
                                       subRoute.key !== 'LeaveConfirm' && 
                                       subRoute.key !== 'ListForManager' && 
                                       subRoute.key !== 'LeaveCreate' &&
                                       subRoute.key !== 'LeaveCancel' &&
                                       subRoute.key !== 'AbstainTimeConfirm' &&
                                       subRoute.key !== 'WelfareConfirm' &&
                                       subRoute.key !== 'workHistory' &&
                                       subRoute.key !== 'SecuritySettings' ? 
                                          <Menu.Item key={subRoute.key} className="show-submenu-nab">
                                             {/* <Icon type={subRoute.icon} /> */}
                                             <Link
                                                to={{
                                                   pathname: route.path + subRoute.path,
                                                   state: {
                                                      fetchKey: subRoute.fetchKey,
                                                      empCodeProfile: profile ? profile.employeeCodes[0] : ''
                                                   }
                                                }}
                                                onClick={() => window.scrollTo({
                                                   top: 0,
                                                   left: 0,
                                                   behavior: 'smooth'
                                                })}
                                                style={{ display: 'inline' }}
                                             >
                                                {/* {subRoute.label} */}
                                                {subRoute.label}

                                                {
                                                   (subRoute.key == 'hospitalConfirm') &&
                                                   <Badge count={totalWdHospitalCount} id="value-wdHospital-subtitle" className=" ml-2" style={{ fontSize:"10px",padding:"0 4px 0 3px" }}></Badge>
                                                }
                                                
                                                {
                                                   (subRoute.key == 'LeaveConfirm') &&
                                                   <Badge count={totalLeaveCount} id="value-LeaveCount-subtitle" className=" ml-2" style={{ fontSize:"10px",padding:"0 4px 0 3px" }}></Badge>
                                                }
                                                {/* <div className="menu-heightshow">
                                                   {subRoute.label}
                                                </div> */}
                                             </Link>
                                          </Menu.Item>
                                       :  
                                         subRoute.key == 'SecuritySettings' ? 
                                         subRoute.isShowSubmenuDynamic.includes(profile.isKCMH) &&
                                         <Menu.Item key={subRoute.key} className="show-submenu-nab">
                                             <Link
                                                to={{
                                                   pathname: route.path + subRoute.path,
                                                   state: {
                                                      fetchKey: subRoute.fetchKey,
                                                      empCodeProfile: profile ? profile.employeeCodes[0] : ''
                                                   }
                                                }}
                                                onClick={() => window.scrollTo({
                                                   top: 0,
                                                   left: 0,
                                                   behavior: 'smooth'
                                                })}
                                                style={{ display: 'inline' }}
                                             >
                                                {subRoute.label}
                                             </Link>
                                          </Menu.Item>
                                          :
                                          this.checkShowMenuApproves(subRoute.key) &&
                                             <Menu.Item key={subRoute.key} className="show-submenu-nab">
                                                {/* <Icon type={subRoute.icon} /> */}
                                                <Link
                                                   to={{
                                                      pathname: route.path + subRoute.path,
                                                      state: {
                                                         fetchKey: subRoute.fetchKey,
                                                         empCodeProfile: profile ? profile.employeeCodes[0] : ''
                                                      }
                                                   }}
                                                   onClick={() => window.scrollTo({
                                                      top: 0,
                                                      left: 0,
                                                      behavior: 'smooth'
                                                   })}
                                                   style={{ display: 'inline' }}
                                                >
                                                   {subRoute.label}
                                                   {
                                                      (subRoute.key == 'hospitalConfirm') &&
                                                      <Badge count={totalWdHospitalCount} id="value-wdHospital-subtitle" className=" ml-2" style={{ fontSize:"10px",padding:"0 4px 0 3px" }}></Badge>
                                                   }
                                                   
                                                   {
                                                      (subRoute.key == 'LeaveConfirm') &&
                                                      <Badge count={totalLeaveCount} id="value-LeaveCount-subtitle" className=" ml-2" style={{ fontSize:"10px",padding:"0 4px 0 3px" }}></Badge>
                                                   }
                                                   {/* <div className="menu-heightshow">
                                                      {subRoute.label}
                                                   </div> */}
                                                </Link>
                                             </Menu.Item>
											)
									)}
								</SubMenu>
							) : (
									(route.key == 'policy') ?  
										profile.isPlasma !== 1 &&
										<SubMenu
											key={route.key}
											title={
												<span>
													<Icon type={route.icon} />
													<span>{route.label}</span>
												</span>
											}
											className="active-menu-custom"
										>
												
											{ 
											// console.log('submenuPolicy',submenuPolicy.length)
												(route.key == 'policy' && submenuPolicy ) &&
												this.renderSubmenuDynamic(route.path, submenuPolicy)
											}
											{
                                 route.children.map(
												subRoute =>
													//เช็คจุฬา
													subRoute.isShowSubmenuDynamic && (
														subRoute.isShowSubmenuDynamic.includes(profile.isKCMH) && (
															<Menu.Item key={subRoute.key} className="show-submenu-nab">
																<Link
																	to={{
																		pathname: route.path + subRoute.path,
																		state: {
																			fetchKey: subRoute.fetchKey,
																			empCodeProfile: profile ? profile.employeeCodes[0] : ''
																		}
																	}}
																	onClick={() => window.scrollTo({
																		top: 0,
																		left: 0,
																		behavior: 'smooth'
																	})}
																	style={{ display: 'inline' }}
																>
																	{subRoute.label}
																	{/* <div className="menu-heightshow">
																		{subRoute.label}
																	</div> */}
																</Link>
															</Menu.Item>
														)
													)
											)}
										</SubMenu>
									:
										route.key !== 'Delegate' ?					
											<Menu.Item key={route.key} className="menu-nonelist">
												<Icon type={route.icon} />
												<Link
													to={{
														pathname: route.path,
														state: {
															empCodeProfile: profile ? profile.employeeCodes[0] : ''
														}
													}}
													onClick={() => window.scrollTo({
														top: 0,
														left: 0,
														behavior: 'smooth'
													})}
													style={{ display: collapsed ? 'block' : 'inline' }}
												>
													{route.label}
													{
														(route.key == 'notification' && totalNotfiction !== 0 ) &&
														<Badge count={totalNotfiction} id="test-value" className=" ml-2" style={{ fontSize:"10px",padding:"0 4px 0 3px" }}></Badge>
													}
													
													{/* totalWdHospitalCount, totalLeaveCount */}
												</Link>
											</Menu.Item>
										:
											this.checkShowMenuApproves(route.key) &&
												<Menu.Item key={route.key} className="menu-nonelist">
													<Icon type={route.icon} />
													<Link
														to={{
															pathname: route.path,
															state: {
																empCodeProfile: profile ? profile.employeeCodes[0] : ''
															}
														}}
														onClick={() => window.scrollTo({
															top: 0,
															left: 0,
															behavior: 'smooth'
														})}
														style={{ display: collapsed ? 'block' : 'inline' }}
													>
														{route.label}
														{
															(route.key == 'notification' && totalNotfiction !== 0 ) &&
															<Badge count={totalNotfiction} id="test-value" className=" ml-2" style={{ fontSize:"10px",padding:"0 4px 0 3px" }}></Badge>
														}
														
														{/* totalWdHospitalCount, totalLeaveCount */}
													</Link>
												</Menu.Item>
								)
						) : null
					)}
				</Menu>
			}
		</>
	}

	fetchPolicyLastVersion = async () => {
		const { client } = this.props
		const { data } = await client.query({
			query: Queries.fetchPolicyLastVersion,
		})
		await this.setState({
			policy: data.fetchPolicyLastVersion
		})
	}

	mutateConsent = async () => {
		const { client } = this.props
		try {
			const { data } = await client.mutate({
				mutation: Mutations.createConsent,
				variables: {
					// empCode: this.state.profile.employeeCodes[0],
					policyId: this.state.policy.policyId,
				}
			})
		} catch (e) {
			// console.log('data', e)
		}
	}

	renderUserMenu = () => {
		const { profile } = this.state
		const { history } = this.props
		return (
			<Menu>
				<Menu.Item
					style={{
						cursor: 'default',
						padding: 20,
						display: 'flex',
						flexDirection: 'row'
					}}
				>
					<Avatar
						icon="user"
						size={96}
						src={
							profile.filesGrouping.files.length
								? profile.filesGrouping.files[0].fileUrl
								: undefined
						}
						style={{ marginRight: 20 }}
					/>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'space-between'
						}}
					>
						<b>{`${profile.firstName} ${profile.lastName}`}</b>
						<span>{profile.email}</span>
						<Button type="primary" onClick={() => history.push('/profileSettings')}>
							Profile Settings
						</Button>
					</div>
				</Menu.Item>
				<Menu.Divider />
				<Menu.Item onClick={this.logout}>
					<Icon type="logout" />
					Logout
				</Menu.Item>
			</Menu>
		)
	}

	accordingProfile = async () => {
		const { client } = this.props
		const { profile } = this.state
		try {
			const { data, errors } = await client.query({
				query: Queries.accordingProfile,
			})
			if (data.accordingProfile.length > 1) {
				this.setState({
					organizationShow: true,
					selectOrganization: data.accordingProfile
				})
			}
		} catch (error) {
			console.log('error', error)
			// message.error(error)
			// const errorMessage = error.graphQLErrors[0].message
		}
	}

	onOkInputCardId = async (e) => {
		const { form, client } = this.props
		const { captcha } = this.state

		e.preventDefault()
		form.validateFields((err, values) => {
			if (!err) {
				const { data, errors } = client.mutate({
					mutation: Mutations.changeCurrentProfile,
					variables: {
						currentProfle: values.changeCurrentProfile,
					}
				})
				message.success("ทำการสลับบัญชีผู้ใช้เรียบร้อย")
				setTimeout(() => {
					window.location.href = '/profile/list'
				}, 1000);
			}
		})
	}

	showModalOrganization = async () => {
		this.setState({
			visibleModalCardNoOG: true
		})
	}

	handleCancelOG = async () => {
		this.setState({
			visibleModalCardNoOG: false
		})
	}

	formModalOrganization = () => {
		const { form } = this.props
		const { selectOrganization, visibleModalCardNoOG, profile } = this.state
		const { getFieldDecorator } = form

		return (
			<>
				<Modal
					visible={visibleModalCardNoOG}
					title="สลับบัญชีผู้ใช้"
					onCancel={this.handleCancelOG}
					footer={[
						<>
							<Button key="submit" type="primary" className="color-white" onClick={this.onOkInputCardId}>
								ตกลง
							</Button>
							<Button key="submit" onClick={this.handleCancelOG}>
								ยกเลิก
							</Button>
						</>
					]}
				>
					<Form style={{ width: "100%" }}>
						<Form.Item label={<b>สำนัก</b>} name="changeCurrentProfile" style={{ marginBottom: '0' }}>
							{getFieldDecorator('changeCurrentProfile', {
								initialValue: profile ? profile.currentProfile : '',
								rules: [{ required: true, message: 'Please input your changeCurrentProfile!' }]
							})(
								<Select
									showSearch
									style={{ width: '100%' }}
									placeholder="เลือกสำนัก"
									filterOption={(input, option) =>
										option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
								>
									{
										selectOrganization.map(item => (
											<Select.Option key={item.workProfile.organization.orgName} value={item.profileKey}>
												{ item.workProfile.orgPosition.positionName+' '+item.workProfile.orgUnit.orgUnitName+' '+item.workProfile.organization.orgName }
											</Select.Option>
										)
										)
									}
								</Select>
							)}
						</Form.Item>
					</Form>
				</Modal>
			</>
		)
	}

	renderHeader = () => {
		const { profile, collapsed, imageContent } = this.state
		return (
			<>
				<div align="center" style={{ margin: '10px 0px 40px 0px' }} width="100%">
					<img src={logo} alt="logo" style={{ maxWidth: '100%', height: '100px' }} />
				</div>
				<div align="center" style={{ margin: '40px 0px 30px 0px' }} width="100%">
					<div style={{ width: collapsed ? '75%' : '120px' }}>
						{
							imageContent &&
								<AvatarProfile imgProfile={  imageContent.image } typeFile={ imageContent.mimeType } showImage={"img"} />
							||
								<AvatarProfile imgProfile={profile.gender == "Female" ? women : men}  showImage={"Avatar"} />
						}
					</div>
					<div style={{ display: collapsed ? 'none' : '' }}>
						<Title level={4} style={{ marginTop: 10, marginBottom: 5 }} className="">
							{
								profile &&
								<>
									{/* สมชาย อยู่เจริญ */}
									{profile.title}{profile.firstName} {profile.lastName}
								</>
							}
						</Title>
						{/* <Text className=" ">ศัลยแพทย์</Text><br></br> */}
						<Button type="primary btn-color-transparent btn-custom btn-custom-logout mt-3" onClick={this.logout}>
							ออกจากระบบ
						</Button>
					</div>
					<Menu
						theme="dark"
						defaultSelectedKeys={[initialKey]}
						selectedKeys={this.getSelectedKeys()}
						mode="inline"
						style={{ display: collapsed ? '' : 'none' }}
					>
						<Menu.Item key="2" onClick={this.logout}>
							<Icon type="logout" />
							<Link style={{ display: collapsed ? 'block' : 'inline' }}>
								Logout
							</Link>
						</Menu.Item>
					</Menu>
				</div>
			</>
		)
	}

	getSelectedKeys = () => {
		const { location } = this.props
		const selectedKeys = location.pathname
			.split('/')
			.filter(path => !!path)
			.splice(0, 2)

		return selectedKeys[0]
	}

	handleOkVersion = async () => {
		localStorage.setItem('showModalVersion', false)
		await this.setState({
			showModalVersion: false,
		});
	};

	handleCancelVersion = () => {
		localStorage.setItem('showModalVersion', false)
		this.setState({ showModalVersion: false });
	};

	fetchCountAllNotification = async () =>{
		const { client } = this.props
		const { data } = await client.query({
			query: Queries.fetchCountAllNotification,
		})

		sessionStorage.setItem('notiCouts', data.fetchCountAllNotification);

		await this.setState({
			totalNotfiction: data.fetchCountAllNotification
		})
	}

	fetchCountListAllApproving = async () =>{
		const { client } = this.props
		const { data } = await client.query({
			query: Queries.fetchCountListAllApproving,
		})

		await this.setState({
			totalWdHospitalCount: data.fetchCountListAllApproving ? data.fetchCountListAllApproving.wdHospitalCount : 0,
			totalLeaveCount: data.fetchCountListAllApproving ? data.fetchCountListAllApproving.leaveCount : 0
		})
	}

	async componentDidUpdate(prevProps, prevState) {
		const { totalNotfiction, totalLeaveCount, totalWdHospitalCount, profile } = this.state
		const { location } = this.props
		if(prevProps.location.pathname !== location.pathname){
         if(profile){
            let userId = null;
            let param = profile.employeeCodes[0];
            let sourceDb = profile.currentProfile.split(':')[1];
            let path = this.props.location.pathname;

            sendToeventLog(userId, param, sourceDb, path);
         }
         

			await this.fetchCountAllNotification()
		}else{
			if(prevState.totalNotfiction !== parseInt(getNotiCouts())){
				await this.fetchCountAllNotification()
			}else{
				if(location.pathname == '/notification'){
					if(totalNotfiction !== parseInt(getNotiCouts())){
						this.setState({
							totalNotfiction: getNotiCouts() ? parseInt(getNotiCouts()) : 0
						})
					}
				}
			}
			// if(prevState.totalWdHospitalCount !== parseInt(getTotalWdHospitalCount()) || prevState.totalLeaveCount !== parseInt(getTotalLeaveCount())){
			// 	console.log('get 2()',getTotalLeaveCount())
			// 	await this.fetchCountListAllApproving()
			// }else{
			// 	if(location.pathname == '/Leave/Confirm' || location.pathname == '/hospital/Confirm'){
			// 		if(totalWdHospitalCount !== parseInt(getTotalWdHospitalCount())){
			// 			this.setState({
			// 				totalWdHospitalCount: getTotalWdHospitalCount() ? parseInt(getTotalWdHospitalCount()) : 0
			// 			})
			// 		}

			// 		console.log('getTotalLeaveCount()',getTotalLeaveCount())

			// 		if(totalLeaveCount !== parseInt(getTotalLeaveCount())){
			// 			this.setState({
			// 				totalLeaveCount: getTotalLeaveCount() ? parseInt(getTotalLeaveCount()) : 0
			// 			})
			// 		}
			// 	}
			// }
		}

		// if(prevState.profile.ImageContent){
		// 	console.log('ssssss')
		// }
	}

	componentWillMount() {
		const { location, history } = this.props
		if (location.pathname === '/') {
			history.replace(`/${initialKey}`)
		}
	}

	hidePopupCookie = async () =>{
		localStorage.setItem('popupCookie', moment().format('L'));
		await this.setState({
			popupCookie: false
		})
	}

	getInfoAuth = async () =>{
		// axiosAPI.post(`${checkLinkURL()}SSOService/checkPasswordExpiredDate`,
		// {
		// 	username: sessionStorage.getItem('username'),
		// })
		// .then(response => {
		// 	console.log("response SSO", response)
		// 	if(response.data.success){
		// 		this.setState({
		// 			visibleCheckPassword: true
		// 		})
		// 	}else{
		// 		this.setState({
		// 			visibleCheckPassword: false
		// 		})
		// 	}

		// }).catch(
		// 	error => console.error(`Error: ${error}`)
		// )

      // console.log("moment().format('L')", passwordDecrypt())
      // if(localStorage.getItem('expiredDate') == moment().add('1','year').format('YYYY-MM-DD')){

      // console.log('isAfter 1', moment(moment(localStorage.getItem('expiredDate')).format('YYYY-MM-DD')).valueOf())
      // console.log('isAfter 2', moment(moment().format('YYYY-MM-DD')).valueOf())
      // console.log('isAfter 3', localStorage.getItem('expiredDate'))
      // console.log('isAfter 4', moment().isAfter(moment(localStorage.getItem('expiredDate'))))
      console.log('isAfter 1', moment().format("YYYY-MM-DD"))
      console.log('isAfter 3', localStorage.getItem('expiredDate'))

      // if(moment().isAfter(moment(moment(localStorage.getItem('expiredDate')).format('YYYY-MM-DD')))){
      if(localStorage.getItem('expiredDate') == "Y"){
         this.setState({
            visibleCheckPassword: true
         })
      }
	}

	newPasswordExpiredDate = async () =>{
		// axiosAPI.post(`${checkLinkURL()}SSOService/newPasswordExpiredDate`,
		// {
		// 	username: sessionStorage.getItem('username'),
		// })
		// .then(response => {
		// 	console.log("response SSO : newPasswordExpiredDate :", response)
		// 	this.setState({
		// 		visibleCheckPassword: false
		// 	})

		// }).catch(
		// 	error => console.error(`Error: ${error}`)
		// )

      const DataFetchAPI = await axiosAPI.post(
         `
            ${checkLinkURL()}SSOService/changePassword`,
            {
               username: sessionStorage.getItem('username'),
               newpassword: passwordDecrypt()
            },
      );

      console.log("DataFetchAPI", DataFetchAPI)

      if(DataFetchAPI.data.success){
         localStorage.setItem('expiredDate', 'N')
         // localStorage.setItem('expiredDate', moment().format('YYYY-MM-DD'))
         this.setState({
      		visibleCheckPassword: false
      	})
      }else{
         this.setState({
            loadingFullPage: false
         })
         message.error(DataFetchAPI.data.message)
         // message.error('รหัส OTP ไม่ถูกต้อง')
      }
	}

	async componentDidMount() {
		// sessionStorage.setItem('popupCookie', moment().format('L'));
		// if(getCookiePopupCookie() == moment().format('L')){
		// 	await this.setState({
		// 		popupCookie: false
		// 	})
		// }else{
		// 	await this.setState({
		// 		popupCookie: true
		// 	})
		// }
		// await this.fetchPolicyLastVersion()
		// if(getCookiePopupCookie() == moment().format('L')){
		// 	await this.setState({
		// 		popupCookie: false
		// 	})
		// }else{
		// 	await this.setState({
		// 		popupCookie: true
		// 	})
		// }
		
		await this.getInfoAuth()
		await this.fetchProfile()
		// await this.fetchPolicyLastVersion()
		await this.accordingProfile()
		await this.fetchListDocumentGroup()
		await this.fetchCountAllNotification()
		// await this.fetchCountListAllApproving()
	}

	render() {
		const { collapsed, totalNotfiction, profile, popupCookie, loaddingFullPage } = this.state
		const { history } = this.props

		return (
			<>
				{!loaddingFullPage &&
					<>
						<Modal
							title=""
							// visible={this.state.visibleCheckPassword}
                     visible={false}
							closable={false}
							maskClosable={false}
							footer={null}
						>
							<Row gutter={16}>
								<Col className="mb-3" span={24}>
									<div align="center">
										<div className='mb-3'>
											<Icon type="bell" style={{fontSize:"24px"}}/>
										</div>
										<div className='mb-3'>
											<b 
												style={{ fontSize:"18px", color:"#000" }}
											>
												แจ้งเตือนรหัสผ่านครบ 1 ปี
											</b><br></br>
											<p className='mt-2'>
												ท่านใช้งานรหัสผ่านเดิมมามากกว่า 1 ปี<br></br>
												กรุณาทำการเปลี่ยนรหัสผ่าน เพื่อเพิ่มความปลอดภัย
											</p>
										</div>
									</div>
								</Col>
								<Col span={24}>
									<div align="center">
										<Button 
											className='mr-md-1' 
											type="primary btn-color-transparent btn-custom btn-cutom-width mb-2" 
											htmlType="submit" 
											onClick={this.newPasswordExpiredDate} 
										>
											ใช้รหัสผ่านเดิม
										</Button>
										<Button 
											className='mr-md-1' 
											type="primary btn-custom btn-cutom-width mb-2" 
											htmlType="submit" 
											style={{ backgroundColor:"#178991" }}
										>
											<Link
												to={{
													pathname: "/profile/resetPassword"
												}}
												onClick={
													() => {
															window.scrollTo({
																top: 0,
																left: 0,
																behavior: 'smooth'
															});
															this.setState({
																visibleCheckPassword: false
															})
														}
													}
											>
												
												เปลี่ยนรหัสผ่าน
											</Link>
										</Button>
									</div>
								</Col>
							</Row>
							
							
							
						</Modal>
						{/* <Modal
							destroyOnClose={true}
							maskClosable={false}
							title="แบบสอบถาม"
							visible={popupCookie}
							footer={""}
							onCancel={this.hidePopupCookie}
							width="650px"
						>
							<a href="https://portal.redcross.or.th/survey" target="_blank">
								<img src={imagePopup}  style={{ width:"100%" }} className="mb-3"/>
								ทำแบบสอบถาม
							</a>
						</Modal> */}
						<Layout style={{ minHeight: '100vh' }}>
							<Layout style={{ minHeight: '100%' }}>
								<Sider collapsible collapsed={collapsed} onCollapse={this.onCollapse} width="240">
									{
										<>
											{this.renderHeader(profile)}
											{this.renderSideMenu()}
										</>
									}
								</Sider>
								<Layout>
									{/* <Header>
										<Row className="py-5">
											<Col span={3}>
											</Col>
										</Row>
									</Header> */}
									{renderAllRoutes()}
									<Footer style={{ textAlign: 'center' }} className="color-white">
										สงวนลิขสิทธิ์ โดย สภากาชาดไทย<br></br> เลขที่ 1871 ถนนพระราม 4 แขวงปทุมวัน เขตปทุมวัน กรุงเทพฯ 10330<br></br>
										{/* Powered by : Kasikornbank Public Co., Ltd. */}
										<Text className="text-web-app" style={{ backgroundColor:"rgb(255 255 255 / 55%);" }}>
											{ versionWeb() } {appVersion()}
										</Text>
									</Footer>
								</Layout>
							</Layout>
						</Layout>
					</>
					||
					<Spin style={{ marginLeft: "50%", marginTop: "20%" }} size="large" />
				}
			</>
		)
	}
}

SiderLayout.propTypes = {
	location: PropTypes.object,
	history: PropTypes.object
}

const WrappedSiderLayout = Form.create()(SiderLayout)

export default withApollo(WrappedSiderLayout)